import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UpdateGridRowDto } from 'src/app/interfaces/Dtos/grid-data.dto';

@Injectable({
  providedIn: 'root'
})
export class GridServiceService {
  private getSelectedRows = new Subject()
  selectedRowsObservable = this.getSelectedRows.asObservable()

  private recieveSelectedRows = new Subject<any>();
  recieveSelectedRowsObservable = this.recieveSelectedRows.asObservable();

  private _clearSelectedRows = new Subject();
  clearSelectedRowsObservable = this._clearSelectedRows.asObservable();

  private _updateRow = new Subject<UpdateGridRowDto>();
  UpdateRowObservable = this._updateRow.asObservable();

  private _moveRow = new Subject<string>();
  moveRowObservable = this._moveRow.asObservable();

  private _emitMoveRowData = new Subject<any>();
  emitMoveRowDataObservable = this._emitMoveRowData.asObservable();

  clearSelectedRows(){
    this._clearSelectedRows.next()
  }

  requestSelectedRows() {
    this.getSelectedRows.next()
  }

  sendSelectedRows(any) {
    this.recieveSelectedRows.next(any)
  }

  UpdateRow(row: UpdateGridRowDto) {
    this._updateRow.next(row)
  }

  moveRow(movement: string) {
    this._moveRow.next(movement)
  }

  emitMoveRowData(data: any) {
    this._emitMoveRowData.next(data)
  }
}
